import { RichText } from 'components/atoms/RichText';
import Link from 'components/atoms/Link/Link';
import { FilterSearchPageHeadingProps } from './FilterSearchPageHeading.types';
import styles from './FilterSearchPageHeading.module.css'; // ✅ përdorim i CSS Module

export const FilterSearchPageHeading: React.FC<FilterSearchPageHeadingProps> = ({
  className,
  slices,
}) => {
  if (!slices) return null;

  const slice = slices.find((sliceItem) => sliceItem.slice_type === 'filtersucheseite-heading');
  if (!slice) return null;

  const { content, button_link, button_text } = slice.primary;

  return (
    <div className={className}>
      <RichText rich_text={content} />

      {button_link?.url && (
        <div style={{ marginTop: '24px' }}>
          <Link
            skin="tertiaryBig"
            url={button_link}
            target={button_link.target || '_self'}
            className={`${styles.customBlueButton} tertiaryBig`}
          >
            {button_text || 'Jetzt entdecken'}
          </Link>
        </div>
      )}
    </div>
  );
};
